export default {
  PFHandbookProBlack: require('./typography/PFHandbookPro/PFHandbookProBlack.woff'),
  PFHandbookProBold: require('./typography/PFHandbookPro/PFHandbookProBold.woff'),
  PFHandbookProMedium: require('./typography/PFHandbookPro/PFHandbookProMedium.woff'),
  PFHandbookProRegular: require('./typography/PFHandbookPro/PFHandbookProRegular.woff'),
  PFHandbookProItalic: require('./typography/PFHandbookPro/PFHandbookProItalic.woff'),
  PFHandbookProThin: require('./typography/PFHandbookPro/PFHandbookProThin.woff'),
  PFHandbookProExtraThin: require('./typography/PFHandbookPro/PFHandbookProExtraThin.woff'),
}
